/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Table filter styled components
 *
 * @author Vlaidslav Oshkanov
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.10.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../../theme';
import { IAttrStyled } from '../../../../../types/globalTypes';

export const FilterTitleTextStyled = styled.div`
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FilterTitleTextWithIconStyled = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FilterColorCircleStyled = styled.div`
    margin-right: 8px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: ${(props) => props.color ? props.color : ''}
`;

export const FilterTitleStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `filter__title ${className}`,
}))<IAttrStyled>`
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 0;
    color: ${colors.tableFilterTitleColor};

    &:hover, &.active {
        color: ${colors.tableFilterTitleColorActive};
    }

    &.active::before {
      content: '';
      position: absolute;
      display: block;
      width: 100%;
      height: 2px;
      top: 0;
      left: 0;
      background: ${colors.pageDashboardChartRecurringChargesForRatePlan};
    }

    &.sortable {
        cursor: pointer;
    }
`;

export const FilterTimeContainerStyled = styled.div`
    display: flex;
`;

export const FilterTimePickerContainerStyled = styled.div`
    width: 224px;
`;

export const FilterTextStyled = styled.div.attrs({
    className: 'filter__text',
})`
    display: flex;
    flex-grow: 1;

    .filter__title-icon {
        margin-left: 8px;
    }
`
